import colors from '@/legacy-src/rebrand/colors'

export const pageBlockColorVariants = {
  // targetting next sibling needs to be done through arbitrary class in tailwind
  // see https://stackoverflow.com/a/76562080
  default: '',
  white: 'bg-white [&+.bg-white]:!pt-0',
  sand: 'bg-sand-500 [&+.bg-sand-500]:!pt-0',
  'sand-400': 'bg-sand-400 [&+.bg-sand-400]:!pt-0',
  'sand-500': 'bg-sand-500 [&+.bg-sand-500]:!pt-0',
  'sand-600': 'bg-sand-600 [&+.bg-sand-600]:!pt-0',
  blue: 'bg-blue-500 [&+.bg-blue-500]:!pt-0',
  yellow: 'bg-yellow-500 [&+.bg-yellow-500]:!pt-0',
  pink: 'bg-pink-500 [&+.bg-pink-500]:!pt-0',
  petrol: 'bg-petrol-500 text-white [&+.bg-petrol-500]:!pt-0',
  'hearme-purple': 'bg-hearme-purple [&+.bg-hearme-purple]:!pt-0 text-white',
}

export const simpleColorVariants = {
  // targetting next sibling needs to be done through arbitrary class in tailwind
  // see https://stackoverflow.com/a/76562080
  default: '',
  white: 'bg-white',
  sand: 'bg-sand-500',
  'sand-400': 'bg-sand-400',
  'sand-500': 'bg-sand-500',
  'sand-600': 'bg-sand-600',
  blue: 'bg-blue-500',
  yellow: 'bg-yellow-500',
  pink: 'bg-pink-500',
  petrol: 'bg-petrol-500 text-white',
  'hearme-purple': 'bg-hearme-purple text-white',
}

export const getBgColor = (color: string, isPageBlock?: boolean) =>
  isPageBlock ? pageBlockColorVariants[color] : simpleColorVariants[color]

export const getTextColor = (color: string) =>
  ({
    default: '',
    light: 'text-white',
    dark: 'text-petrol-500',
  })[color]

export const getColor = (color: string) =>
  ({
    blue: colors.blue[500],
    yellow: colors.yellow[500],
    pink: colors.pink[500],
  })[color]
